var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"severityTag"},[_c('el-tag',{attrs:{"type":_vm.severityItem.tag,"effect":"dark","color":_vm.severityItem.color,"size":"mini"}},[_vm._v(_vm._s(_vm.$t('severityTag.' + _vm.severityItem.label.toLowerCase())))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }